import * as React from "react";
import { HudFPSDisplay } from "../../fps-display/HudFPSDisplay";
import { HudHappiness } from "../../happiness/HudHappiness";
import { HudPlayerProfile } from "../../player-profile/HudPlayerProfile";
import { HudPlayerProfilePicture } from "../../player-profile/HudPlayerProfilePicture";
import { HudWorkers } from "../../workers/HudWorkers";
export var BF2HudTopLeft = function () { return (React.createElement("div", { className: "flex flex--row__reverse h100" },
    React.createElement(HudFPSDisplay, null),
    React.createElement("div", { className: "flex flex--stacked hud-player-base-profile-name" },
        React.createElement("div", { className: "flex flex--stacked w100" },
            React.createElement(HudPlayerProfile, null)),
        React.createElement("div", { className: "hud-player-base-happiness flex flex--row flex--spaced w100" },
            React.createElement(HudHappiness, null),
            React.createElement(HudWorkers, null))),
    React.createElement(HudPlayerProfilePicture, null))); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudTopLeft.tsx
// module id = 2302
// module chunks = 3